import React from 'react';
import styles from './Quiz.module.css';
import { Link, withRouter } from 'react-router-dom';
import * as utils from '../../utils/utils';

export default class Quiz extends React.Component {

    constructor(props) {
        super(props);

        const isDev = (process.env.NODE_ENV === 'development');

        if ( isDev ) {
            this.scheme = 'vibegame-app-dev';
        }
        else {
            this.scheme = 'vibegame-app';
        }

        this.nickname = this.props.match.params.nickname || '';

        this.state = {
            isLoading: true,

            user: null,
        };
    };

    componentDidMount() {
        if ( this.nickname !== '' ) {
            utils.sendRequest('/web/quiz/getQuestionFromNickname',{
                nickname: this.nickname,
            })
            .then(responseData => {
                const {
                    user,
                } = responseData;
    
                this.setState({
                    user,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log('error', error);
            });
        }
    };

    renderUserPic = () => {
        const {
            user
        } = this.state;

        if ( user.pic == null || user.pic === '' ) {
            return (
                <div className={styles.userPic}>
                    <div className={styles.userNoPicText}>{user.firstName.substr(0, 1)} {user.lastName.substr(0, 1)}</div>
                </div>
            );
        }
        else {
            return (
                <img className={styles.userPic} src={user.pic} />
            );
        }
    };

    render() {
        const {
            isLoading,
            user
        } = this.state;

        if ( isLoading ) {
            return (
                <div>Loading...</div>
            )
        }

        return (
            <div className={styles.rootView}>
                {/* <img src={require('../../assets/animation.gif')} className={styles.background} /> */}
                <div className={styles.background} />
                <div className={styles.backgroundOverlay} />

                <div className={styles.content}>
                    <div className={styles.logoView}>
                        <img className={styles.vibeImage} src={require('../../assets/vibe.png')} />
                    </div>

                    <a href={`${this.scheme}://nickname/${this.nickname}`}>
                        <div className={styles.userView}>
                            {this.renderUserPic()}
                            <div className={styles.userInfoView}>
                                <div className={styles.userName}>{user.firstName} {user.lastName}</div>
                                <div className={styles.numNewQuizText}>{user.numQuizzes} New Quizzes</div>
                            </div>
                        </div>

                        {
                            user != null &&
                            user.question != null &&
                            <>
                                <div className={styles.questionNumText}>
                                    Question 1 of 8
                                </div>

                                <div className={styles.questionView}>
                                    <div className={styles.questionText}>{user.question.q}</div>
                                </div>
                                <div className={styles.answersView}>
                                    <div className={styles.answerItemView}>{user.question.options[0]}</div>
                                    <div className={styles.answerItemView}>{user.question.options[1]}</div>

                                    <div className={styles.answerItemView}>{user.question.options[2]}</div>
                                    <div className={styles.answerItemView}>{user.question.options[3]}</div>
                                </div>
                            </>
                        }
                    </a>

                    <a href="https://apps.apple.com/app/vibe-game/id6478194603">
                        <div className={styles.downloadView}>
                            <div className={styles.downloadText}>
                                <div>Download Vibe Game to</div>
                                <div>Create Your Quiz, Take Friends' Quizzes, and</div>
                                <div>See Who Knows You The Best!</div>
                            </div>
                        </div>
                    </a>

                    <a href="https://apps.apple.com/app/vibe-game/id6478194603">
                        <img src={require('../../assets/appstore.png')} className={styles.appstore} />
                    </a>

                    <div className={styles.footer}>
                        <a href='mailto:vibegameapp@gmail.com' className={styles.link}>Help</a>
                        <Link to="/terms" className={styles.link}>Terms</Link>
                        <Link to="/privacy" className={styles.link}>Privacy</Link>
                    </div>
                    <div className={styles.copyright}>© KVK LLC. 2024</div>
                </div>

            </div>
        );
    };
};